<div class="container">

  <!-- FILTERS -->
  <div class="filters-expand-md">
    <div class="toggle-filters">
      <button type="button" class="btn btn-outline-secondary collapsed" data-bs-toggle="collapse" data-bs-target="#collapseFilters" aria-expanded="false" aria-controls="collapseFilters">Filtros <i class="fa fa-sliders" aria-hidden="true"></i></button>
    </div>
    <div id="collapseFilters" class="collapse">
      <div class="filters mb-4">
        <form [formGroup]="dataform" (ngSubmit)="search()">
          <div class="title mb-3">Filtros</div>
          <div class="cont__filters_fields row">
            <div class="col-md-6 mb-2">
              <div class="box__range_dates">
                <div class="subtitle begin">Pago cliente*</div>
                <div class="cont_range">
                  <div class="w-100">
                    <label class="form-label">Fecha inicio</label>
                    <div>
                      <input #fechatransaccionInit formControlName="CashoutDateInit" value="{{ filter.cashoutDateInit | date:'yyyy-MM-dd' }}" (focus)="inputDateFocus(fechatransaccionInit)" (blur)="inputDateBlur(fechatransaccionInit)" (change)="inputDateBlur(fechatransaccionInit)" type="date" id="dtPublish">
                    </div>
                  </div>
                  <div class="w-100">
                    <label class="form-label">Fecha fin</label>
                    <div>
                      <input #fechatransaccionEnd formControlName="CashoutDateEnd" value="{{ filter.cashoutDateEnd | date:'yyyy-MM-dd' }}" (focus)="inputDateFocus(fechatransaccionEnd)" (blur)="inputDateBlur(fechatransaccionEnd)" (change)="inputDateBlur(fechatransaccionEnd)" type="date" id="dtPublish">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <div class="box__range_dates">
                <div class="subtitle close">Transferencia red</div>
                <div class="cont_range">
                  <div class="w-100">
                    <label class="form-label">Fecha inicio</label>
                    <div>
                      <input #fechatransferenciaInit formControlName="OrderCreationDateInit" value="{{ filter.orderCreationDateInit | date:'yyyy-MM-dd' }}" (focus)="inputDateFocus(fechatransferenciaInit)" (blur)="inputDateBlur(fechatransferenciaInit)" (change)="inputDateBlur(fechatransferenciaInit)" type="date" id="dtPublish">
                    </div>
                  </div>
                  <div class="w-100">
                    <label class="form-label">Fecha fin</label>
                    <div>
                      <input #fechatransferenciaEnd formControlName="OrderCreationDateEnd" value="{{ filter.orderCreationDateEnd | date:'yyyy-MM-dd' }}" (focus)="inputDateFocus(fechatransferenciaEnd)" (blur)="inputDateBlur(fechatransferenciaEnd)" (change)="inputDateBlur(fechatransferenciaEnd)" type="date" id="dtPublish">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cont__filters_fields row">
            <div class="col mb-3">
              <label class="form-label">Estado de la transferencia**</label>
              <select2 formControlName="IdStatus" [value]="statusDefaultValue" [data]="statusData" [multiple]="false">
              </select2>
            </div>
            <div class="col mb-3">
              <label class="form-label">Nº de cuenta Punto de Red</label>
              <select2 formControlName="AccountNumber" [value]="accountNumberDefaultValue" [data]="accountNumberData" [multiple]="false">
              </select2>
            </div>
            <div *ngIf="showCif" class="col mb-3">
              <label class="form-label">CIF</label>
              <select2 formControlName="TaxNumber" [value]="taxNumberDefaultValue" [data]="taxNumberData" [multiple]="false">
              </select2>
            </div>
          </div>
          <div class="cont__filters_fields row">
            <div class="mt-3 buttons__filter">
              <button type="submit" class="btn-yw">
                Filtrar</button>
              <button type="button" (click)="resetFilters()" class="btn-line-primary">Limpiar filtros</button>
            </div>
            <div class="mt-3 w-100">
              <div class="form-help">
                * Fecha de la transacción del pago online realizada entre el cliente y Lyra (proveedor del servicio de pago online).<br>
                ** Transferencia: transacción realizada entre Lyra y el Punto de Red.​
              </div>
            </div>
          </div>
        </form>
        <div class="toggle-filters">
          <button class="btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFilters" aria-expanded="false" aria-controls="collapseFilters"> <i class="fa fa-angle-up fa-2x" aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Filters -->

  <div class="row mt-4">
    <div class="col-md-6 col-lg-4 pe-3 mb-4">
      <div class="data__card">
        <div class="data-card-title">Importe total</div>
        <div class="data-card-data"> {{dashboard.TotalCashoutAmount}}</div>
      </div>
    </div>
    <div class="col-md-6 col-lg-3 pe-3 mb-4">
      <div class="data__card">
        <div class="data-card-title">Total de pagos online</div>
        <div class="data-card-data"> {{dashboard.TotalCashoutCount}}</div>
      </div>
    </div>

    <div class="col-lg-5 mb-4">
      <div class="data__card">
        <div class="data-card-title border-bottom">Estado de las transacciones</div>
        <div class="row g-0">
          <div *ngFor="let elem of dashboard.Status" class="col-6 col-sm col-lg-6 col-xl-3">
            <div class="data-card-subtitle">{{elem.Status}}</div>
            <div class="data-card-data" [ngClass]="{'text-success': elem.Status === 'exitoso', 'text-danger' : elem.Status === 'fallido', 'text-darkgrey' : elem.Status === 'en espera','text-warning' : elem.Status === 'cancelado' }">
              {{elem.Count}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isAdminRenault && canDownloadExcel" class="row">
    <div class="col">
      <button type="button" (click)="downloadExcel()" class="btn btn-outline-secondary btn-excel">
        Descargar Excel</button>
    </div>
  </div>

  <div [hidden]="!showDataTable" class="row pb-5">
    <div class="col">
      <div class="table-responsive-xl table__resume">
        <table id="tblcarrusel" datatable [dtOptions]="dtOptions1" [dtTrigger]="dtTrigger1" class="table data-tables w-100">
          <thead>
            <tr>
              <th class="text-center bg-mediumgrey border-bottom border-white" colspan="3">Datos del Punto de Red</th>
              <th class="text-center bg-darkgrey border-bottom border-white" colspan="2">Datos del cliente
              </th>
              <th class="text-center bg-primary text-white border-bottom border-white" colspan="7">Datos de la transacción</th>
            </tr>
            <tr>
              <th class="text-center bg-mediumgrey">Dealer ID</th>
              <th class="text-center bg-mediumgrey">Nombre</th>
              <th class="text-center bg-mediumgrey">CIF</th>
              <th class="text-center bg-darkgrey">Nombre</th>
              <th class="text-center bg-darkgrey">Apellidos</th>
              <th class="text-center bg-primary text-white">Nº pedido</th>
              <th class="text-center bg-primary text-white">Descripción pedido</th>
              <th class="text-center bg-primary text-white">Fecha pago cliente</th>
              <th class="text-center bg-primary text-white">Estado</th>
              <th class="text-center bg-primary text-white">Importe</th>
              <th class="text-center bg-primary text-white">Fecha transferencia red</th>
              <th class="text-center bg-primary text-white">Nº transferencia</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
  <div [hidden]="!showDataTableLog" class="row pb-5">
    <div class="col">
      <div class="table__resume table-responsive-md">
        <table id="tblcarrusel" datatable [dtOptions]="dtOptions2" [dtTrigger]="dtTrigger2" class="table data-tables w-100">
          <thead>
            <tr>
              <th class="text-center bg-mediumgrey" width="146px">Fecha subida fichero</th>
              <th class="text-start bg-mediumgrey">Usuario</th>
              <th class="text-end bg-mediumgrey" width="96px">Importe total</th>
              <th class="text-center bg-primary">Cantidad transacciones</th>
              <th class="text-center bg-primary">Exitosas</th>
              <th class="text-center bg-primary">Fallidas</th>
              <th class="text-center bg-primary">En espera</th>
              <th class="text-center bg-primary">Canceladas</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- NO BORRAR EJ. RANGO FECHAS PENDIENTE DE IMPLEMENTAR
<form class="row row-cols-sm-auto">
    <div class="col-12">
        <div class="dp-hidden position-absolute">
            <div class="input-group">
                <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker" [container]="'body'" [autoClose]="'outside'" (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate!" tabindex="-1">
                <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                        {{ date.day }}
                    </span>
                </ng-template>
            </div>
        </div>
        <input type="hidden" #dpFromDate class="form-control" placeholder="dd-mm-yyyy" name="dpFromDate" [value]="formatter.format(fromDate)" (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
        <input (click)="datepicker.toggle()" type="text" [value]="(formatter.format(fromDate) | date:'dd-MM-yyyy') + ' - ' + (formatter.format(toDate) | date:'dd-MM-yyyy')">
    </div>
    <div class="col-12">
        <input type="hidden" #dpToDate class="form-control" placeholder="dd-mm-yyyy" name="dpToDate" [value]="formatter.format(toDate)" (input)="toDate = validateInput(toDate, dpToDate.value)">
    </div>
</form>

<hr />
<pre>From date model: {{ fromDate | json }}</pre>
<pre>To date model: {{ toDate | json }}</pre>
 -->




<div class="modal fade" #modalDescription id="modalDescription" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="1" aria-labelledby="modalSearchLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title">Descripción del pedido</div>
        <button type="button" class="btn-close" id="closeModalFileButton" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        {{orderDescription}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>